import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {SearchBO} from "@/service/common.s";
import {ForeheadPO} from "@/model/finance";

export enum ForeheadEnum {
    GetForeheadPage = "/forehead/getForeheadPage",
    GetForehead = "/forehead/getForehead",
    CreateForehead = "/forehead/createForehead",
    UpdateForehead = "/forehead/updateForehead",
    SearchForehead = "/forehead/searchForehead",
}

export interface ForeheadPageBO {
    keyword?: string;
}

export interface ForeheadPageVO extends ReviewStatusVO, ForeheadPO {
    location: string
}

export interface ForeheadVO extends ForeheadPO {
    creator: string
}

export interface SearchForeheadVO extends Omit<ForeheadPO, "creatorId" | "createdAt"> {
}

export const useQueryForeheadPage = () => useMutation({
    mutationFn: (data: ForeheadPageBO) => http.post<BaseVO<PaginationVO<ForeheadPageVO>>>({
        url: ForeheadEnum.GetForeheadPage,
        data: data,
    }),
})

export const useQueryForehead = (params: GetByIdBO, enabled = true) => useQuery({
    queryKey: [params.id],
    queryFn: () => http.get<BaseVO<ForeheadVO>>({url: ForeheadEnum.GetForehead, params}),
    enabled
});

export const useSearchForehead = () => useMutation({
    mutationFn: (data: SearchBO) => http.post<BaseVO<SearchForeheadVO[]>>({
        url: ForeheadEnum.SearchForehead,
        data: data
    })
})

export const useCreateForehead = () => useMutation({
    mutationFn: (data: any) => http.put<BaseVO<null>>({url: ForeheadEnum.CreateForehead, data}),
})

export const useUpdateForehead = () => useMutation({
    mutationFn: (data: any) => http.post<BaseVO<null>>({url: ForeheadEnum.UpdateForehead, data}),
})

